import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable, isDevMode } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { environment } from '../../environments/environment';

const endpoint: string = environment.apiUrl;
const clientId: string = environment.eInvoisClientId;
const clientSecret: string = environment.eInvoisClientSecret;

const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json'
  })
};

@Injectable({
  providedIn: 'root'
})

export class EInvoicingService {

  constructor(private http: HttpClient) {}

  // Login to LHDN myInvois portal as taxpayer
  login() {
    return this.http.post(endpoint + '/api/e-invoice/lhdn/connect', {
      client_id: clientId,
      client_secret: clientSecret,
      grant_type: 'client_credentials',
      scope: 'InvoicingAPI',
      production : isDevMode() ? false : true
    }, httpOptions);
  }

  // Login to LHDN myInvois portal as intermediary
  intermediaryLogin(tin: string) {
    return this.http.post(endpoint + '/api/e-invoice/lhdn/connect-intermediary', {
      client_id: clientId,
      client_secret: clientSecret,
      grant_type: 'client_credentials',
      scope: 'InvoicingAPI',
      on_behalf_of: tin,
      production : isDevMode() ? false : true
    }, httpOptions);
  }

  // Validate the TIN
  validateTIN(tin : string, idType : string, idValue : string){
    return this.http.post(endpoint + '/api/e-invoice/lhdn/validate-tin', {
      access_token: localStorage.getItem('einvois_access_token'),
      tin: tin,
      idType : idType,
      idValue : idValue,
      production : isDevMode() ? false : true
    }, httpOptions);
  }

  // Search taxpayer TIN
  searchTaxpayerTIN(idType : string, idValue : string){
    return this.http.post(endpoint + '/api/e-invoice/lhdn/search-tin', {
      access_token: localStorage.getItem('einvois_access_token'),
      idType : idType,
      idValue : idValue,
      production : isDevMode() ? false : true
    }, httpOptions);
  }

  // Get document details by UUID
  getDocument(uuid : string) {
    return this.http.post(endpoint + '/api/e-invoice/lhdn/get-document', {
      access_token: localStorage.getItem('einvois_access_token'),
      uuid: uuid,
      production : isDevMode() ? false : true
    }, httpOptions);
  }

  // Cancel document by UUID
  cancelDocument(uuid : string) {
    return this.http.post(endpoint + '/api/e-invoice/lhdn/cancel-document', {
      access_token: localStorage.getItem('einvois_access_token'),
      uuid: uuid,
      production : isDevMode() ? false : true
    }, httpOptions);
  }

  // Reject document by UUID
  rejectDocument(uuid : string) {
    return this.http.post(endpoint + '/api/e-invoice/lhdn/reject-document', {
      access_token: localStorage.getItem('einvois_access_token'),
      uuid: uuid,
      production : isDevMode() ? false : true
    }, httpOptions);
  }
  
  // Submit document to LHDN myInvois portal
  submitDocument(invoice : any, onBehalfOfTIN: string, onBehalfOfBRN: string) {
    return this.http.post(endpoint + '/api/e-invoice/lhdn/submit-document', {
      access_token: localStorage.getItem('einvois_access_token'),
      issuer_tin : onBehalfOfTIN,
      issuer_brn : onBehalfOfBRN,
      production : isDevMode() ? false : true,
      invoice : {
        'InvoiceId' : invoice.InvoiceId ?? 'INV00001',
        'IssueDate' : invoice.IssueDate ?? '',
        'IssueTime' : invoice.IssueTime ?? '',
        'DocumentCurrencyCode' : invoice.DocumentCurrencyCode ?? 'MYR',
        'SupplierName' : invoice.SupplierName ?? 'Supplier Name',
        'SupplierEmail' : invoice.SupplierEmail ?? '',
        'SupplierTelephone' : invoice.SupplierTelephone ?? '0121234567',
        'SupplierStreetName' : invoice.SupplierStreetName ?? '',
        'SupplierCityName' : invoice.SupplierCityName ?? 'city',
        'SupplierCountrySubentity' : invoice.SupplierCountrySubentity ?? '01',
        'SupplierPostalZone' : invoice.SupplierPostalZone ?? '00000',
        'SupplierCountry' : invoice.SupplierCountry ?? 'MYS',
        'SupplierAddressLine' : invoice.SupplierAddressLine ?? 'address line',
        'CustomerName' : invoice.CustomerName ?? 'Customer Name',
        'CustomerEmail' : invoice.CustomerEmail ?? '',
        'CustomerTelephone' : invoice.CustomerTelephone ?? '0121234567',
        'CustomerStreetName' : invoice.CustomerStreetName ?? '',
        'CustomerCityName' : invoice.CustomerCityName ?? 'city',
        'CustomerCountrySubentity' : invoice.CustomerCountrySubentity ?? '01',
        'CustomerPostalZone' : invoice.CustomerPostalZone ?? '00000',
        'CustomerCountry' : invoice.CustomerCountry ?? 'MYS',
        'CustomerAddressLine' : invoice.CustomerAddressLine ?? 'address line',
        'CustomerShippingAddress' : invoice.CustomerShippingAddress ?? 'shipping address',
        'ItemDescription' : invoice.ItemDescription ?? 'Invoice Item',
        'TotalTaxAmount' : invoice.TotalTaxAmount ?? 0,
        'TotalExcludingTax' : invoice.TotalExcludingTax ?? 0,
        'TotalIncludingTax' : invoice.TotalIncludingTax ?? 0,
        'TotalPayableAmount' : invoice.TotalPayableAmount ?? 0,
        'CustomerTIN' : invoice.CustomerTIN ?? 'C21998774020',
        'CustomerBRN' : invoice.CustomerBRN ?? '000001',
        'DeliveryTIN' : invoice.DeliveryTIN ?? 'IG20067472020',
        'DeliveryBRN' : invoice.DeliveryBRN ?? '000001',
      },
    }, httpOptions);
  }

    // Submit document to LHDN myInvois portal
    submitDocumentWithoutDefaultValue(invoice : any, onBehalfOfTIN: string, onBehalfOfBRN: string) {
      return this.http.post(endpoint + '/api/e-invoice/lhdn/submit-document', {
        access_token: localStorage.getItem('einvois_access_token'),
        issuer_tin : onBehalfOfTIN,
        issuer_brn : onBehalfOfBRN,
        production : isDevMode() ? false : true,
        invoice : {
          'InvoiceId' : invoice.InvoiceId,
          'IssueDate' : invoice.IssueDate,
          'IssueTime' : invoice.IssueTime,
          'DocumentCurrencyCode' : invoice.DocumentCurrencyCode,
          'SupplierName' : invoice.SupplierName,
          'SupplierEmail' : invoice.SupplierEmail,
          'SupplierTelephone' : invoice.SupplierTelephone,
          'SupplierStreetName' : invoice.SupplierStreetName ?? '',
          'SupplierCityName' : invoice.SupplierCityName,
          'SupplierCountrySubentity' : invoice.SupplierCountrySubentity,
          'SupplierPostalZone' : invoice.SupplierPostalZone,
          'SupplierCountry' : invoice.SupplierCountry,
          'SupplierAddressLine' : invoice.SupplierAddressLine,
          'CustomerName' : invoice.CustomerName,
          'CustomerEmail' : invoice.CustomerEmail,
          'CustomerTelephone' : invoice.CustomerTelephone,
          'CustomerStreetName' : invoice.CustomerStreetName ?? '',
          'CustomerCityName' : invoice.CustomerCityName,
          'CustomerCountrySubentity' : invoice.CustomerCountrySubentity,
          'CustomerPostalZone' : invoice.CustomerPostalZone,
          'CustomerCountry' : invoice.CustomerCountry,
          'CustomerAddressLine' : invoice.CustomerAddressLine,
          'CustomerShippingAddress' : invoice.CustomerShippingAddress,
          'ItemDescription' : invoice.ItemDescription,
          'TotalTaxAmount' : invoice.TotalTaxAmount,
          'TotalExcludingTax' : invoice.TotalExcludingTax,
          'TotalIncludingTax' : invoice.TotalIncludingTax,
          'TotalPayableAmount' : invoice.TotalPayableAmount,
          'CustomerTIN' : invoice.CustomerTIN,
          'CustomerBRN' : invoice.CustomerBRN,
          'DeliveryTIN' : invoice.DeliveryTIN,
          'DeliveryBRN' : invoice.DeliveryBRN,
        },
      }, httpOptions);
    }

  setToken (token: string): void {
    localStorage.setItem('einvois_access_token', token) 
  }
}
